import { Box, styled, Tabs, tabsClasses } from '@mui/material';
import { LwTab } from 'redesign';
import { useTranslation } from 'react-i18next';
import { WorkFormCreationTabsProps } from './work-form-creation-tabs.types';
import { WorkFormCreationType } from '../work-form-creation-type.types';

export const WorkFormCreationTabs = ({
  creationType,
  onCreationTypeChange,
}: WorkFormCreationTabsProps) => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <TabsContainer>
      <CreationTabs
        value={creationType}
        onChange={(_, value: WorkFormCreationType) => onCreationTypeChange(value)}
        aria-label={t('work-form.creation-tabs.aria-label')}
      >
        <LwTab
          value="single"
          label={t('work-form.creation-tabs.single')}
          data-testid="work-form-creation-tab-single"
        />
        <LwTab
          value="multi-day"
          label={t('work-form.creation-tabs.multi-day')}
          data-testid="work-form-creation-tab-multi-day"
        />
      </CreationTabs>
    </TabsContainer>
  );
};

const TabsContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

const CreationTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 'unset',
  [`& .${tabsClasses.flexContainer}`]: {
    gap: theme.spacing(8),
  },
}));
